import { ContractsPage } from './Contracts';
import { SalesProPage } from './SalesPro';
import { OptOutEliseAiPage } from './OptOutEliseAI';
import { emitVisitContractsPageEvent, emitVisitSalesProPageEvent } from '@/analytics/events';
import type { ZrmClickstreamUser } from '@zg-rentals/clickstream';

export enum TabbedPageEnum {
  SalesPro = 'sales-pro',
  Contracts = 'contracts',
  EliseDataSharing = 'data-sharing',
}

export enum TabbedPageFeatureFlags {}

export type TabbedPageComponentProps = {};

export type TabbedPageConfigItem = {
  page: TabbedPageEnum;
  title: string;
  Component: React.FC<TabbedPageComponentProps>;
  featureFlag?: TabbedPageFeatureFlags;
  pageVisitEvent?: ({ user }: { user: ZrmClickstreamUser }) => void;
  allowOnlyForImpersonators?: boolean;
  blockForNonAdvertisers?: boolean;
  allowOnlyForMultifamilyCustomers?: boolean;
};

export const tabbedPageConfig: Array<TabbedPageConfigItem> = [
  {
    page: TabbedPageEnum.SalesPro,
    title: 'Sales Pro',
    Component: SalesProPage,
    pageVisitEvent: emitVisitSalesProPageEvent,
  },
  {
    page: TabbedPageEnum.Contracts,
    title: 'Contracts',
    Component: ContractsPage,
    blockForNonAdvertisers: true,
    pageVisitEvent: emitVisitContractsPageEvent,
  },
  {
    page: TabbedPageEnum.EliseDataSharing,
    title: 'Data Sharing',
    Component: OptOutEliseAiPage,
    blockForNonAdvertisers: true,
    allowOnlyForMultifamilyCustomers: true,
  },
];
